import React from 'react';

// Types
// import { UpdateAiTemplateTypeType } from 'Shared/types/UpdateAiTemplate.type';

// Hooks
import { useUpdateAiTemplates } from 'Shared/utils/hooks/use-update-ai-templates';

// Components
import UpdateAiTempalteItem from './UpdateAiTempalteItem';

// Styles
import './UpdateAiSelectTemplate.scss';

const UpdateAiSelectTemplate = () => {
  const { templates, isLoadingTemplates } = useUpdateAiTemplates();

  const baseClassName = 'UpdateAiSelectTemplate';
  return (
    <div className={baseClassName}>
      {isLoadingTemplates && <>loading templates...</>}
      {templates.map(template => (
        <UpdateAiTempalteItem key={template.slug} template={template} />
      ))}
    </div>
  );
};

export default UpdateAiSelectTemplate;
